import Sentry from "@similarweb/sentry-logger";
import isRouteToSales from "app/helpers/is/isRouteToSales";
import userActivityService from "app/pages/sales-intelligence/services/userActivityService";
/*
!!! Important
Be careful and avoid importing the whole SI bundle.
Import only isolated modules and files.
*/

export const siBootstrap = async (): Promise<boolean> => {
    try {
        if (!isRouteToSales()) {
            return false;
        }

        window.similarweb = window.similarweb || {};

        const userActivityData = await userActivityService.fetch();

        window.similarweb.userActivityData = userActivityData;

        return true;
    } catch (e) {
        Sentry.errorTracker({ message: "siBootstrap failed", e, level: "error" });
        return false;
    }
};
